// api/exportInvoiceSaleApi.ts
import apiHandler from "../core/apiHandler";

const exportInvoiceSaleApi = apiHandler('export-invoice-sales');
export default exportInvoiceSaleApi;
